import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import atomize from '@quarkly/atomize';
import { commonTextProps, commonTextPropsDefaults } from './text';
export default atomize.span({
  name: 'Span',
  normalize: true,
  mixins: true,
  description: {
    en: 'Text element — text in different variants: paragraph, heading, etc.',
    ru: 'Элемент text — текст в различных вариантах: параграф, заголовок, и другие'
  },
  propInfo: _objectSpread({
    as: {
      type: 'string',
      category: 'Main',
      control: 'select',
      variants: ['span', 'label']
    }
  }, commonTextProps)
}, _objectSpread({
  as: 'span'
}, commonTextPropsDefaults));